import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "M13.333 5.333H6.666c-.736 0-1.333.597-1.333 1.334v6.666c0 .737.597 1.334 1.333 1.334h6.667c.736 0 1.333-.597 1.333-1.334V6.667c0-.737-.597-1.334-1.333-1.334"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "M2.666 10.667c-.733 0-1.333-.6-1.333-1.334V2.667c0-.734.6-1.334 1.333-1.334h6.667c.733 0 1.333.6 1.333 1.334"
    }, null, -1)
  ]))]))
}
export default { render: render }